import interceptor from '../common/interceptor';
import { APIPaths } from '../common/constants';
import { ApiResponse } from './types';
import { AxiosResponse } from 'axios';

export const GetReportDetails = (
  query: string,
  token: string
): Promise<ApiResponse> => {
  const url = `${APIPaths.gxp_resports}${query}`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet('Get', url, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log('error while getting report', error?.response);
        reject(error?.response);
      });
  });
};
export const GetReportCharts = (
  query: string,
  token: string
): Promise<ApiResponse> => {
  const url = `${APIPaths.gxp_resports}${query}`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGet('Get', url, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log('error while getting Report chart', error?.response);
        reject(error?.response);
      });
  });
};

export const PublishReport = (
  token: string,
  id?: string,
  model?: Record<string, unknown>
): Promise<ApiResponse> => {
  return new Promise((resolve, reject) => {
    const url = `${APIPaths.gxp_resports}${id}/disposition/`;

    interceptor
      .axiosPost('Post', `${url}`, model ?? null, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.log('Publish Report Error:', error?.response);
        reject(error?.response);
      });
  });
};

export const ExportReport = (
  query: string,
  token: string
): Promise<AxiosResponse<Blob>> => {
  const url = `${APIPaths.gxp_resports}${query}`;
  return new Promise((resolve, reject) => {
    interceptor
      .axiosGetDownload('Get', url, token, null)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log('error while getting report', error?.response);
        reject(error?.response);
      });
  });
};

export const DismissGxPAlert = (
  token: string,
  id?: string,
  model?: Record<string, unknown>
): Promise<ApiResponse> => {
  return new Promise((resolve, reject) => {
    const url = `${APIPaths.gxp_resports}${id}/dismiss-banner/`;
    interceptor
      .axiosPost('Post', `${url}`, model ?? null, token)
      .then((res) => resolve(res))
      .catch((error) => {
        console.log('Dismiss GxP Alert Error:', error?.response);
        reject(error?.response);
      });
  });
};
